import { useEffect, useRef } from 'react'

const DURATION_MS = 1200

export default function BonusUseAnimation({ emoji, onDone, startPos }) {
  const onDoneRef = useRef(onDone)
  useEffect(() => {
    const t = setTimeout(() => onDoneRef.current(), DURATION_MS)
    return () => clearTimeout(t)
  }, [])

  if (startPos) {
    // ~half of 1.8rem emoji at start (16px base = 28.8px → 14px half)
    const half = 14
    const sl = `${Math.round(startPos.x - half)}px`
    const sb = `${Math.round(window.innerHeight - startPos.y - half)}px`

    // Desktop : centrer dans le volet droit (aside w-96 = 24rem)
    const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize)
    const asideWidth = 24 * remPx
    const emojiHalfPx = 1.875 * remPx
    const endLeft = `${Math.round(window.innerWidth - asideWidth / 2 - emojiHalfPx)}px`

    const style = `
@keyframes bonusFly {
  0%   { bottom: ${sb}; left: ${sl}; font-size: 1.8rem; opacity: 1; }
  60%  { bottom: 45vh; left: ${endLeft}; font-size: 3.75rem; opacity: 1; }
  85%  { bottom: 45vh; left: ${endLeft}; font-size: 3.75rem; opacity: 1; }
  100% { bottom: 45vh; left: ${endLeft}; font-size: 3.75rem; opacity: 0; }
}
.bonus-fly {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  animation: bonusFly ${DURATION_MS}ms ease-in-out forwards;
  line-height: 1;
}
`
    return (
      <>
        <style>{style}</style>
        <span className="bonus-fly" aria-hidden="true">{emoji}</span>
      </>
    )
  }

  return (
    <div className="fixed inset-0 z-50 pointer-events-none flex items-center justify-center">
      <span className="text-6xl animate-bounce">{emoji}</span>
    </div>
  )
}
